export default __webpack_public_path__ + "static/media/Image-3.962a1815.jpg";